// =====================================================================
// Doctor's "come back when" window — shared chip catalog + label helper
// =====================================================================
// Used by both the chairside Future Needs card (Doctor.jsx) and the
// receptionist's Step 3 banner (Checkout.jsx) so the same human label
// renders on both ends of the workflow ("come back in 2 weeks").
//
// `days` of NULL means "System default" — no doctor override; the
// booking dialog falls back to the procedure-category default
// (Restorative ≈ 10 days, Preventive ≈ 90, etc.). Whenever the doctor
// picks one of the named windows (1 week, 2 weeks, etc.) THAT becomes
// the doctor's choice.
//
// Bounded 1..730 by the SQL CHECK constraint on
// public.treatment_needs.follow_up_after_days.
// =====================================================================

export const SESSION_FOLLOW_UP_OPTIONS = [
  { days: null, label: "System default" },
  { days: 1,    label: "Tomorrow" },
  { days: 3,    label: "3 days" },
  { days: 7,    label: "1 week" },
  { days: 14,   label: "2 weeks" },
  { days: 30,   label: "1 month" },
  { days: 42,   label: "6 weeks" },
  { days: 90,   label: "3 months" },
  { days: 180,  label: "6 months" },
];

// Map a days value to a doctor-friendly label ("come back in 2 weeks").
// Falls through to "X days" / "X weeks" / "X months" for any custom
// value outside the canonical chip set.
export function describeFollowUpDays(days) {
  if (days == null) return "no preference";
  const exact = SESSION_FOLLOW_UP_OPTIONS.find((o) => o.days === days);
  if (exact) return exact.label;
  if (days <= 14)  return `${days} day${days === 1 ? "" : "s"}`;
  if (days <= 60)  return `${Math.round(days / 7)} weeks`;
  if (days <= 365) return `${Math.round(days / 30)} months`;
  return `${days} days`;
}
